import React from 'react';
import styles from './DialogStyles.module.scss';
import { DialogContent } from '@material-ui/core';

export default function DialogBody({ children }) {
  return <DialogContent classes={{ root: styles.popupText }}>{children}</DialogContent>;
}
